import { DynamicAnimation } from "./DynamicAnimation"

export default DynamicAnimation
